import { converters as tableConverters } from 'store/table';
import { loaders } from './admin-terms.loaders';

export const converters = {
  getTerms: ({ data }: Awaited<ReturnType<typeof loaders.getTerms>>) => {
    const { total, page, pageSize, pages } = tableConverters.getTableData(data);

    return {
      items: data.data,
      total,
      page,
      pageSize,
      pages,
    };
  },
  getTerm: ({ data }: Awaited<ReturnType<typeof loaders.getTerm>>) => data,
};
